import { Alert, Flex } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useGetProjectByProjectIdIssueAndIssueIdLogsQuery } from "../../../../../../../openapi";
import { HistoryLogsTable } from "../../../../../../components/HistoryLogsTable/HistoryLogsTable";
import { IIssueModalSectionProps } from "./IssueItemModalMantine";

const IssueModalLogs = ({ issueBoard, issue, projectId }: IIssueModalSectionProps) => {
  const {
    data: logs,
    isLoading,
    isError,
    error,
  } = useGetProjectByProjectIdIssueAndIssueIdLogsQuery({ projectId, issueId: issue._id }, { skip: !issue._id });

  return isError === true ? (
    <Alert variant="light" color="red" title="Alert title" icon={<IconInfoCircle />}>
      Feil ved lasting av loggdata: {JSON.stringify(error)}
    </Alert>
  ) : (
    <Flex h="100%" w="100%">
      <HistoryLogsTable
        isLoading={isLoading}
        logData={logs}
        otherAttributesConfig={issueBoard.otherAttributesConfig}
        risikoConfig={issueBoard.risikoSection}
      />
    </Flex>
  );
};

export default IssueModalLogs;
